import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Card, CardContent, Divider, colors } from '@material-ui/core'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {},
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  solicitacoesButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.blueGrey[900]} 30%, ${colors.blueGrey[900]} 90%)`,
    color: 'white',
  },
  encaminharButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.orange[900]} 30%, ${colors.orange[900]} 90%)`,
    color: 'white',
  },
  exameButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.blue[900]} 30%, ${colors.blue[900]} 90%)`,
    color: 'white',
  },
  botoes: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(4),
  },
  inner: {
    minWidth: 400,
  },
  actions: {
    justifyContent: 'flex-end',
  },
  arrowForwardIcon: {
    marginLeft: theme.spacing(1),
  },
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export const DetailPanel = (props) => {
  moment.locale('pt-br', localization)
  const { className, dados, ...rest } = props
  const classes = useStyles()
  const [requestBody, setRequestBody] = useState([])

  // CONTROLE DAS TABS
  const [value, setValue] = useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  useEffect(() => {
    if (dados.request.body) {
      setRequestBody(Object.entries(dados.request.body))
    }
  }, [dados.request.body])

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Divider />

      <AppBar color="transparent" position="static">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Dados Gerais" {...a11yProps(0)} />
          <Tab label="Requisição" {...a11yProps(1)} />
          {dados.usuario && <Tab label="Usuário" {...a11yProps(2)} />}
        </Tabs>
      </AppBar>
      <div>
        <TabPanel value={value} index={0}>
          <CardContent className={classes.content}>
            <PerfectScrollbar>
              <Table className={classes.table} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h4">Informação</Typography>{' '}
                    </TableCell>
                    <TableCell align="right" />
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">ID:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.id}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Código:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.code}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Mensagem:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.message}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Local:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.target}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">HTTP Code:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.httpCode}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h4">Erro Interno</Typography>{' '}
                    </TableCell>
                    <TableCell align="right" />
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Código:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.innerError.code}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Mensagem:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.innerError.message}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </PerfectScrollbar>
          </CardContent>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CardContent className={classes.content}>
            <PerfectScrollbar>
              <Table className={classes.table} aria-label="simple table">
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h4">URL</Typography>{' '}
                    </TableCell>
                    <TableCell align="right" />
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Protocolo:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.request.url.protocol}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Hostname:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.request.url.hostname}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Base:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.request.url.baseUrl}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Path:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.request.url.path}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography variant="h5">Método:</Typography>
                    </TableCell>
                    <TableCell align="left"> {dados.request.method}</TableCell>
                  </TableRow>
                  {dados.request.body && (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h4">Body</Typography>{' '}
                      </TableCell>
                      <TableCell align="right" />
                    </TableRow>
                  )}
                  {requestBody.map(([key, value2]) => (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h5">{key}:</Typography>
                      </TableCell>
                      <TableCell align="left"> {value2}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </PerfectScrollbar>
          </CardContent>
        </TabPanel>
        {dados.usuario && (
          <TabPanel value={value} index={2}>
            <CardContent className={classes.content}>
              <PerfectScrollbar>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h5">Nome:</Typography>
                      </TableCell>
                      <TableCell align="left">
                        {' '}
                        {dados.usuario.pessoal.nome} {dados.usuario.pessoal.sobrenome}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h5">CPF:</Typography>
                      </TableCell>
                      <TableCell align="left"> {dados.usuario.pessoal.cpf}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h5">Matrícula:</Typography>
                      </TableCell>
                      <TableCell align="left"> {dados.usuario.institucional.matricula}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th" scope="row">
                        <Typography variant="h5">Cargo:</Typography>
                      </TableCell>
                      <TableCell align="left"> {dados.usuario.institucional.cargo.nome}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </CardContent>
          </TabPanel>
        )}
      </div>
    </Card>
  )
}
